import { createRouter, createWebHistory } from "vue-router";
import DashboardRoutes from "../modules/dashboard/router/index"
import LoginRoutes from "../modules/login/router/index";
import PedidosRoutes from "../modules/pedidos/router/index"
import ProductosRoutes from "../modules/productos/router/index";
import VehiculosRoutes from "../modules/vehiculos/router/index";
import ContenidoRoutes from "../modules/contenido/router/index";
import { useAuthStore } from "@/stores/authStore";
import { permissionGuard } from "./guards/permissionGuard";

const routes = [
  ...DashboardRoutes,
  ...LoginRoutes,
  ...PedidosRoutes,
  ...ProductosRoutes,
  ...VehiculosRoutes,
  ...ContenidoRoutes,
];

const router = createRouter({
  history: createWebHistory(),
  routes,
});
// Inicializar auth antes de cualquier navegación
let isAuthInitialized = false;


router.beforeEach(async (to, from, next) => {
  const authStore = useAuthStore();

  // Inicializar autenticación solo una vez
  if (!isAuthInitialized) {
    await authStore.initializeAuth();
    isAuthInitialized = true;
  }

  //  Ejecutar permiso sobre la ruta actual
  permissionGuard(to, from, next);
});
export default router;